import { useEffect } from 'react';

type GTagParams = {
  page_path?: string;
  event_category?: string;
  event_label?: string;
  value?: number;
  stream_id?: string;
};

declare global {
  interface Window {
    dataLayer: unknown[];
    gtag: (...args: unknown[]) => void;
  }
}

const GA4_ID = 'G-EVC9V436DH';
const STREAM_ID = '10362752115';

const GoogleAnalytics = () => {
  useEffect(() => {
    // Only load on production domain
    if (!window.location.hostname.includes('abmymix.com')) {
      return;
    }

    // Create gtag stub BEFORE loading Google's script (Google's official pattern)
    window.dataLayer = window.dataLayer || [];
    window.gtag = function() {
      // eslint-disable-next-line prefer-rest-params
      window.dataLayer.push(arguments);
    };

    // Configure immediately after creating stub
    window.gtag('js', new Date());
    window.gtag('config', GA4_ID, {
      page_path: window.location.pathname,
      stream_id: STREAM_ID
    });

    // Load Google's script (which will process the dataLayer)
    const script = document.createElement('script');
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${GA4_ID}`;
    document.head.appendChild(script);

    return () => {
      const existingScript = document.querySelector(`script[src*="${GA4_ID}"]`);
      if (existingScript) {
        document.head.removeChild(existingScript);
      }
    };
  }, []);

  return null;
};

export default GoogleAnalytics; 